import { GlobalStore } from '@roc/feature-app-core';
import {
  generateUUID,
} from '@roc/feature-utils';
import { action, makeObservable, observable } from 'mobx';
import { PropertyFormStore } from './singlePropertyFormStore';

export abstract class PropertiesStore {
  protected globalStore: GlobalStore;
  protected loanSubType: string;

  public propertyFormStore: PropertyFormStore;
  public uploadedLicenses = {};

  public key = generateUUID();

  abstract createPropertyForm(): PropertyFormStore;

  constructor(globalStore) {
    this.globalStore = globalStore;
    this.initialize();
    makeObservable(this, {
      propertyFormStore: observable,
      createPropertyForm: action,
      initialize: action,
      validateAllProperties: action,
    });
  }

  public initialize() {
    this.propertyFormStore = this.createPropertyForm();
  }

  validateAllProperties() {
    let isValid = true;

    const state = this.propertyFormStore.form.fields.state.value;

    this.propertyFormStore.validateAndCleanupProperty();
    isValid = isValid && this.propertyFormStore.form.meta.isValid;
    this.propertyFormStore.setEditMode(!isValid);
    if (!isValid) {
      this.globalStore.notificationStore.showWarningNotification({
        message: 'Please complete all the required fields for the property',
      });
      return false;
    }
    return true;
  }
}
